import { useEffect, useState } from "react"

interface Props {
  endTime: number
  className?: string
}

function formatTimeLeft(endTime: number): string {
  const distance = endTime - Date.now()

  if (distance <= 0) {
    return "00:00"
  }

  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((distance % (1000 * 60)) / 1000)

  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
}

export default function CountdownTimer({ endTime, className }: Props) {
  const [timeLeft, setTimeLeft] = useState(() => formatTimeLeft(endTime))

  useEffect(() => {
    const timer = setInterval(() => {
      const formatted = formatTimeLeft(endTime)
      setTimeLeft(formatted)

      if (formatted === "00:00") {
        clearInterval(timer)
      }
    }, 1000)

    return () => clearInterval(timer)
  }, [endTime])

  if (timeLeft === "00:00") return null

  return <span className={className}>{timeLeft}</span>
}
